var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEggWhole = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 43 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .a{\n        fill:#0f272a;\n        opacity:0.2;\n      }\n      .b{\n        fill:url(#a);\n      }\n      .c{\n        isolation:isolate;\n        fill:url(#b);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: -127026.44,
    cy: -80676.79,
    r: 21.76,
    gradientTransform: "matrix(0.79, 0.08, 0.13, -1.38, 111506.69, -101722.15)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1eeea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -101323.13,
    y1: -111083.42,
    x2: -101323.13,
    y2: -111022.44,
    gradientTransform: "matrix(1, 0.1, 0.1, -1, 111521.15, -100769.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#806540"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#806540",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "egg-whole") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36,27.88c-1.06,11-7.89,15.27-15.72,14.51S6.59,36.18,7.65,25.15,16.33,1.69,24.16,2.44,37.11,16.86,36,27.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.65,27.34c-1,10.84-7.86,15-15.7,14.24s-13.74-6.13-12.69-17,8.64-23,16.47-22.3,13,14.19,11.92,25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M35.65,27.34c-1,10.84-7.86,15-15.7,14.24s-13.74-6.13-12.69-17,8.64-23,16.47-22.3,13,14.19,11.92,25Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEggWhole);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/egg-whole.d9bc3cc567c172da9d69ba896c5e5d4b.svg";